import { type onAfterSaveType } from 'app/main/components/hooks/useModel';
import { DetailsEventsWrapper } from 'app/main/components/page-layouts';
import { sendNotification } from 'app/store/notifications/notificationsConnectionSlice';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (
			modifiedModel.coms_user_assigned_uid &&
			modifiedModel.coms_user_assigned_uid !== model.coms_user_assigned_uid
		) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.coms_user_modified_uid,
						assignedTo: modifiedModel.coms_user_assigned_uid,
						title: 'Nuova Comunicazione assegnata',
						body: `${model.user_modified_title} ti ha assegnato a "${model.coms_title}".`,
						url: `${window.location.origin}/communications/details/${model.coms_uid}`,
						icon: 'newspaper-variant',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params =>
	DetailsEventsWrapper(params.modifiedModel)([sendSaveNotification(params)]);

export default { onAfterSave };
